// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"0f55cd60","349":"a6af1109","548":"ddf5f9e0","787":"be4caf7e"}[chunkId] + ".chunk.js";
};